<template>
  <BasePageContainer>
    <page-header
      has-back>
      カテゴリーの編集
    </page-header>
    <div class="category_edit__body general-form pt-8">
      <category-form
        v-model="categoryFormData"
        is-edit
        @submit="onClickSave()" />
    </div>
  </BasePageContainer>
</template>

<script>
import CategoryForm from '@/components/view/CategoryForm.vue'
import PageHeader from '@/components/parts/PageHeader.vue'

export default {
  components: {
    PageHeader,
    CategoryForm,
  },
  data() {
    return {
      categoryFormData: {
        categoryName: '',
        sortOrder: 0
      }
    }
  },
  computed: {
    categoryId() {
      return this.$route.params.categoryId
    }
  },
  async created() {
    this.$store.commit('startLoading')
    const { data: category } = await this.$axios.get(`/events/categories/${this.categoryId}/`)
      .catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    this.categoryFormData.categoryName = category.name
    this.categoryFormData.sortOrder = category.sortOrder
    this.$store.commit('finishLoading')
  },
  methods: {
    async onClickSave(){
      this.$store.commit('startLoading')
      const params = {
        name: this.categoryFormData.categoryName,
        sort_order: this.categoryFormData.sortOrder
      }
      await this.$axios.patch(`/events/categories/${this.categoryId}/`, params).then(() => {
        this.$store.commit('notify/set', {message: 'カテゴリーを保存しました'})
        this.$router.push('/admin/categories/')
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      this.$store.commit('finishLoading')
    },
    onClickCancel(){
      this.$router.push('/admin/categories/')
    }
  }

}
</script>

<style lang="scss" scoped>
.category_edit-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }

  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
.category_edit{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>